import { useRef, useState } from 'react';

// Hooks
import { useAppSelector } from '../../../hooks/useAppStore';

// Redux-toolkit
import { getShiftDetails } from '../../../store/clock/selectors';

// Utils
import { zeroPrefix } from '../../../utils/helpers';

export function useClock() {
  const shiftDetails = useAppSelector(getShiftDetails);
  const timeBegan = useRef<Date | null>(null);
  const [time, setTime] = useState('00:00:00.00');
  const [breakTime, setBreakTime] = useState('00:00:00.00');
  const started = useRef<any>(null);

  const clockRunning = () => {
    const currentTime = new Date();

    const timeElapsed = new Date(
      currentTime.getTime() - (timeBegan?.current?.getTime() || 0),
    );

    const hour = timeElapsed.getUTCHours();
    const min = timeElapsed.getUTCMinutes();
    const sec = timeElapsed.getUTCSeconds();
    const ms = timeElapsed.getUTCMilliseconds();

    const counter = `${zeroPrefix(hour, 2)
    }:${
      zeroPrefix(min, 2)
    }:${
      zeroPrefix(sec, 2)
    }.${
      zeroPrefix(ms, 2)}`;

    if (shiftDetails.inBreak) {
      setBreakTime(counter);
    }

    setTime(counter);
  };

  const startCounter = (isMainChronometer = true) => {
    const cond = isMainChronometer
      ? !shiftDetails.started
      : !shiftDetails.inBreak;
    if (cond) return;
    if (timeBegan.current === null) {
      timeBegan.current = new Date();
    }

    started.current = setInterval(clockRunning, 10);
  };

  const clearTimer = () => {
    clearInterval(started.current);
    setTime('00:00:00.00');
    setBreakTime('00:00:00.00');
    timeBegan.current = null;
  };

  return {
    startCounter,
    started,
    time,
    breakTime,
    timeBegan,
    clearTimer,
  };
}
